import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { isMobile } from 'app/helpers/utils';

const H2 = styled.h2`
  font-size: ${({ size }) => size}px;
  line-height: ${({ lineHeight }) => lineHeight}px;
  color: ${({ color }) => color};
  font-weight: ${({ weight }) => weight};
  margin: 0;
`;

H2.defaultProps = {
  size: 18,
  lineHeight: 28,
  weight: 300,
  color: '#4e4f57',
};

H2.propTypes = {
  size: PropTypes.number.isRequired,
  lineHeight: PropTypes.number.isRequired,
  weight: PropTypes.number.isRequired,
  color: PropTypes.string.isRequired,
};

export default H2;
